import { Badge, Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { BulkUploadTypes, UploadTypeConfigCallback } from 'constants/bulkUpload';
import { PreviewMetric } from '../BladeComponents/PreviewMetric';
import permissions from 'constants/permissions';
import React from 'react';
import { getPeoplePage } from 'utils/links';

const config: UploadTypeConfigCallback = (data) => ({
  permissions: [permissions.EMPLOYEE_DISMISSAL],
  initiation: {
    feature: 'bulk-fnf',
    permissions: [],
    pageTitle: 'Bulk Full & Final Initiation',
    step1Title: '1. Download the Full & Final Initiation sheet to be updated',
    instructions: [
      'Enter Employee Details',
      'Provide Reason for Dismissal (Optional)',
      'Specify whether to release salary or hold net-pay. If holding net-pay, specify Hold Salary Start Month to an unfinalized payroll month.',
      'The maximum number of rows you can upload is 500',
    ],
    onSampleTemplateDownload(orgId, reportType) {
      window.open(
        `/v2/api/bulk-fnf/download-template?organization_id=${orgId}&type=${reportType}`,
        '_blank',
      );
    },
  },
  preview: {
    permissions: [],
    feature: 'bulk-fnf',
    columns: [
      {
        title: 'ID',
        render: (item) => item.file_row?.commonProperties?.employeeId,
      },
      {
        title: 'Name',
        render: (item) => item.file_row?.commonProperties?.employeeName,
      },
      {
        title: 'Email ID',
        render: (item) => item.file_row?.commonProperties?.email,
      },
      {
        title: 'Last Working Day',
        render: (item) => item.file_row?.lastWorkingDate,
      },
      {
        title: 'Reason for dismissal',
        render: (item) => item.file_row?.reasonForDismissal,
      },
      {
        title: 'Salary Payout',
        render: (item) => {
          const value = (item.file_row?.salaryPayout || '') as string;
          return <Badge color={value === 'Release Salary' ? 'positive' : 'notice'}>{value}</Badge>;
        },
      },
      {
        title: 'Hold salary start month',
        render: (item) => item.file_row?.holdSalaryStartMonth,
      },
      {
        title: 'Personal Email',
        render: (item) => item.file_row?.personalEmail,
      },
    ],
    renderConfirmationText: (data) =>
      `Almost done! Please confirm to initiate the Full & final settlement for the ${data.total_number_of_rows} employees`,
    tableTopView: (bulkUploadRecord) => (
      <Box gap="spacing.6" marginTop="spacing.6" display="flex" flexWrap="wrap">
        <PreviewMetric
          title="Employee net-pay on hold"
          value={bulkUploadRecord?.file_summary?.numberOfNetPayOnHold as string}
        />
        <PreviewMetric
          title="Employee salary to be released"
          value={bulkUploadRecord?.file_summary?.numberOfReleaseSalary as string}
        />
      </Box>
    ),
    successModalCtaText: 'Go to People',
    successModalSubText:
      'The Full and Final settlement process has been initiated for the employees mentioned in the file',
    onSuccessModalCtaClick() {
      const peoplePageUrl = getPeoplePage(data.featureFlags?.employeeOnboarding);
      data.history.push(peoplePageUrl);
    },
    onDownloadErrorReport(history) {
      history?.push({
        pathname: routePaths.bulkUploads.initiate,
        search: `type=${BulkUploadTypes.TYPE_BULK_FNF_INITIATION}`,
      });
    },
  },
});

export default config;
